import React from "react";
import StyledHeader from "./Header.styled";
import Typewriter from "./Typewriter";

const Header = () => {

    const titles = [
        "Digital Transformation Engineer",
        "Technical Data Strategist",
        "Marketing Technologist",
        "Digital Media Creator",
        "Customer Support Engineer",
        "Static Site Generator Specialist"
    ];

    return (
        <StyledHeader id="top">
            <div className="home_wrapper">
                <div className="home_intro text-color-white text-shadow-bottom">
                    <div className="heading-style-h2 tw-bold">Hello! I'm</div>
                    <h1 className="heading-large tw-bold mt-small">Kevin Effertz</h1>
                    <h3 className="heading-xsmall mt-xxsmall"><Typewriter data={titles}/></h3>
                </div>
            </div>
        </StyledHeader>
    );
}

export default Header;